<template>
  <div class="page-main detail">
    <div>
      <div style="margin-bottom: 24px">
        <!-- 面包屑 -->
        <div>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{
                                path: from == 'hasBeenSent' ? '/vgm/send' : '/vgm/draft'
                            }">
              <span v-if="from == 'hasBeenSent'">已发送</span>

              <span v-else>草稿箱</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <span v-if="!type || type == 'import' || type == 'drainage'">新建VGM</span>
              <span v-if="type == 'edit'">编辑VGM</span>
              <span v-if="type == 'copy'">复制VGM</span>
              <span v-if="type == 'see'">查看VGM</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="page-title-box">
        <span class="page-title" v-if="!type || type == 'import' || type == 'drainage'">新建VGM</span>
        <span class="page-title" v-if="type == 'edit'">编辑VGM</span>
        <span class="page-title" v-if="type == 'copy'">复制VGM</span>
        <span class="page-title" v-if="type == 'see'">查看VGM</span>

        <div>
          <el-button style="width: 80px; margin-left: 16px" @click="toBack">返回 </el-button>

          <el-button type="primary" style="width: 136px; margin-left: 16px" @click="saveDraft" v-show="type != 'see'">保存到草稿箱
          </el-button>
        </div>
      </div>
      <el-form ref="form" :model="form" :rules="formCheck" label-width="90px" size="small" label-position="top" :inline="true" :disabled="type == 'see'">
        <div class="form-part">填写基本信息</div>
        <div>
          <!-- <el-form-item label="主提单号" prop="masterBillNo">
                      <el-input v-model="form.masterBillNo" @blur="blurMasterBillNo" placeholder="请输入主提单号" :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" :minlength="6" :maxlength="30" show-word-limit @input="val => toupcaseTable(val, 'masterBillNo')" style="width:320px"></el-input>
                    </el-form-item> -->
          <el-form-item label="选择港口" prop="portCode">
            <el-select v-model="form.portCode" placeholder="请下拉选择" filterable :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" style="width: 320px" @change="changePort">
              <el-option v-for="item in ports" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="选择船公司" prop="carrierCode">
            <el-select v-model="form.carrierCode" placeholder="请下拉选择" filterable style="width: 320px" @change="changeCarrier">
              <el-option v-for="item in carriersList" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="客户备注" prop="remark">
                      <el-input v-model="form.remark" placeholder="请输入客户备注" :disabled="getDisabled" style="width:320px" maxlength="30" show-word-limit></el-input>
                    </el-form-item> -->
        </div>
        <!-- <div class="form-part">船舶信息</div> -->
        <div class="form-box">
          <el-form-item label="提单号" prop="billNo">
            <el-input v-model="form.billNo" placeholder="请输入提单号" style="width: 320px" @input="(val) => toupcaseTable(val, 'billNo')" @blur="(val) => trimTexTablet(val, 'billNo')" maxlength="30" show-word-limit></el-input>
          </el-form-item>
          <el-form-item prop="soNumber" v-if="form.carrierCode == 'WHL' || form.carrierCode == 'HLC'">
            <template slot="label">
              <div>
                <span style="margin-left: 10px">SO号码</span><span style="color: red; margin-left: 8px">{{
                                    form.carrierCode == 'HLC' ? '8位纯数字' : '例如：030C123456'
                                }}</span>
              </div>
            </template>
            <el-input v-model="form.soNumber" placeholder="请输入SO号码" style="width: 320px" @input="(val) => toupcaseTable(val, 'soNumber')" @blur="(val) => trimTexTablet(val, 'soNumber')" :maxlength="form.carrierCode == 'WHL' ? 30 : 8" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="船名" prop="vesselName" v-if="showInfo">
            <el-input v-model="form.vesselName" placeholder="请输入船名" style="width: 320px" @input="(val) => toupcaseTable(val, 'vesselName')" @blur="(val) => trimTexTablet(val, 'vesselName')" maxlength="35" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="航次" prop="voyNo" v-if="showInfo">
            <el-input v-model="form.voyNo" placeholder="请输入航次" style="width: 180px" @input="(val) => toupcaseTable(val, 'voyNo')" @blur="(val) => trimTexTablet(val, 'voyNo')" maxlength="10" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="码头" prop="pier" v-if="showInfo">
            <el-select v-model="form.pier" placeholder="请选择码头" filterable style="width: 320px">
              <el-option v-for="item in pires" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="客户备注" prop="">-->
          <!--            <el-input-->
          <!--                v-model="form.customerCode"-->
          <!--                placeholder="请输入客户备注"-->
          <!--                style="width: 320px"-->
          <!--                @input="val => toupcaseTable(val, 'customerCode')"-->
          <!--                maxlength="30"-->
          <!--                show-word-limit-->
          <!--            ></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item label="SOC箱标记" prop="ownContainer">
            <el-select v-model="form.ownContainer" placeholder="请下拉选择" filterable style="width: 320px">
              <el-option v-for="item in isSocs" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </div>
      </el-form>

      <div class="form-part">集装箱列表</div>
      <div class="containers-list">
        <div>
          <el-button type="primary" style="width: 140px; margin-bottom: 24px" @click="addGoodsDetail" :disabled="type == 'see'">
            <i class="iconfont icon-xinzenghuowumingxi"></i>
            新增集装箱
          </el-button>
          <el-button type="primary" style="margin-bottom: 24px" @click="addContainerDialogVisible = true" :disabled="type == 'see'">
            <i class="iconfont icon-biaogedaoru"></i>
            Excel复制粘贴识别导入
          </el-button>
        </div>
        <el-form ref="tableForm" :model="WTableOpts" size="small" :disabled="type == 'see'">
          <WTable :WTableOpts="WTableOpts" :operation="false">
            <template #containerNo="{ row, $index }">
              <el-form-item :prop="'data.' + $index + '.containerNo'" :rules="formTable.tableRule.containerNo" label-width="0px">
                <el-input v-model="row.containerNo" placeholder="请输入箱号" maxlength="11" show-word-limit @input="(val) => (row.containerNo = val.toUpperCase())" @blur="(e) => (row.containerNo = e.target.value.trim())"></el-input>
              </el-form-item>
            </template>
            <template #vgmWeight="{ row, $index }">
              <el-form-item :prop="'data.' + $index + '.vgmWeight'" :rules="formTable.tableRule.vgmWeight" label-width="0px">
                <el-input v-model="row.vgmWeight" placeholder="请输入VGM重量" maxlength="35" @blur="(e) => (row.vgmWeight = e.target.value.trim())"></el-input>
              </el-form-item>
            </template>
            <template #weighingParty="{ row, $index }">
              <el-form-item :prop="'data.' + $index + '.weighingParty'" :rules="formTable.tableRule.weighingParty" label-width="0px">
                <el-input v-model="row.weighingParty" placeholder="请输入称重方" maxlength="70" show-word-limit class="weight-party" @input="(val) => (row.weighingParty = val.toUpperCase())" @blur="(e) => (row.weighingParty = e.target.value.trim())"></el-input>
              </el-form-item>
            </template>
            <template #signature="{ row, $index }">
              <el-form-item :prop="'data.' + $index + '.signature'" :rules="formTable.tableRule.signature" label-width="0px">
                <el-input v-model="row.signature" placeholder="请输入签名" maxlength="20" show-word-limit @input="(val) => (row.signature = val.toUpperCase())" @blur="(e) => (row.signature = e.target.value.trim())"></el-input>
              </el-form-item>
            </template>
            <template #operation="{ row, $index }">
              <div class="table-btn-box">
                <el-form-item label-width="0px">
                  <el-link type="primary" :disabled="type == 'see'" :underline="false" @click="deleteData(row, $index)">删除
                  </el-link>
                </el-form-item>
              </div>
            </template>
          </WTable>
        </el-form>
      </div>
      <div style="height: 24px"></div>
      <el-dialog :close-on-click-modal="false" title="温馨提示" :visible.sync="dialogVisible" width="360px">
        <span>{{ getDialogTitle }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancle">取 消</el-button>
          <el-button type="primary" @click="submit">确 认</el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog :close-on-click-modal="false" title="新增集装箱" :visible.sync="addContainerDialogVisible" width="720px">
      <div>
        <p class="mb-16px">
          将Excel中的箱信息连表头(箱号、VGM重量、称重方、签名)一起复制粘贴到输入框中，点击确认系统会自动识别并生成箱信息列表。
        </p>
        <el-input type="textarea" :rows="6" placeholder="请将表格内容粘贴到此处" v-model="textarea"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addContainerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAddContainer">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ports } from '@/utils/enum'
import { getShippingCompany, getPiers, getRole } from '@/api/vgmBase'
import { saveDraftBox, editDraftBox, draftBoxDetail, vgmDrainage } from '@/api/vgmBusiness'
import { validNo, validCM, validZW, validSO, validZL, validCZF, validQM, validWHLSO, validateXH } from '@/utils/valid'

export default {
    name: 'Detail',
    components: {},
    props: {},
    data() {
        //箱号
        const regXh = /^[A-Z]{4}[0-9]{7}$/

        const validateXH = (rule, value, callback) => {
            if (regXh.test(value) === false) {
                callback(new Error('箱号不符合国际箱号编码规则'))
            } else {
                let arr = this.WTableOpts.data.filter((v) => {
                    return v.containerNo == value
                })
                if (arr.length > 1) {
                    callback(new Error('箱号重复'))
                } else {
                    callback()
                }
            }
        }
        //签名
        const regQM=/^[A-Z]+$/
        const validQM=(rule, value, callback)=>{
            if (regQM.test(value) === false) {
                callback(new Error('只能输入大写字母'))
            }else if(value.length>20){
                callback(new Error('长度必须小于等于20'))
            }else{
                callback()
            }
        }
        //称重方
        const regCZF=/^[0-9A-Z.,\s()&-]+$/
        const regNB=/^[0-9]+$/
        const validCZF=(rule, value, callback)=>{
            if (regCZF.test(value) === false) {
                callback(new Error('只能输入大写字母，数字和.,()&-'))
            }else if(regNB.test(value) === true){
                callback(new Error('称重方不能纯数字'))
            }else if(value.length>70){
                callback(new Error('长度必须小于等于70'))
            }else{
                callback()
            }
        }
        return {
            ports,
            validSO,
            validCM,
            validateXH,
            validWHLSO,
            addContainerDialogVisible: false,
            dialogVisible: false,
            textarea: '',
            detailBack: {},
            isSocs: [
                {
                    label: '是',
                    value: 'SOC'
                },
                {
                    label: '否',
                    value: 'COC'
                }
            ],

            form: {
                portCode: '', //港口
                carrierCode: '', //接收方
                billNo: '', //提单号
                // customerCode: '',//客户编码
                pier: null, //码头
                soNumber: null, //so号
                vesselName: null, //船名
                voyNo: null, //航次
                ownContainer: 'COC' //是否为soc
            },
            formCheck: {
                portCode: [{ required: true, message: '请选择港口', trigger: 'change' }],
                carrierCode: [{ required: true, message: '请选择船公司' + '', trigger: 'change' }],
                billNo: [
                    { required: true, message: '请输入提单号', trigger: 'blur' },
                    { validator: validNo, trigger: 'blur' },
                    { min: 6, max: 30, message: '长度在6-30之间', trigger: 'blur' }
                ],
                ownContainer: [{ required: true, message: '请选择SOC箱标记', trigger: 'change' }],
                pier: [{ required: true, message: '请选择码头', trigger: 'change' }],
                vesselName: [
                    { required: true, message: '请输入船名', trigger: 'blur' },
                    { validator: validCM, trigger: 'blur' },
                    { min: 1, max: 35, message: '长度在1-35之间', trigger: 'blur' }
                ],
                voyNo: [
                    { required: true, message: '请输入航次', trigger: 'blur' },
                    { validator: validZW, trigger: 'blur' },
                    { min: 1, max: 10, message: '长度在1-10之间', trigger: 'blur' }
                ],
                soNumber: [{ required: true, message: '请输入SO号码', trigger: 'blur' }]
            },
            carriersList: [], //接收方
            carrierType: '', //是什么通道,亿通？
            pires: [
                {
                    value: '上海国际港务（集团）股份有限公司宜东集装箱码头分公司',
                    label: '上海国际港务（集团）股份有限公司宜东集装箱码头分公司'
                },
                {
                    value: '(外一)上海浦东国际集装箱码头有限公司',
                    label: '(外一)上海浦东国际集装箱码头有限公司'
                },
                {
                    value: '(洋一)上海盛东国际集装箱码头有限公司',
                    label: '(洋一)上海盛东国际集装箱码头有限公司'
                },
                {
                    value: '(外四)上海沪东集装箱码头管理有限公司',
                    label: '(外四)上海沪东集装箱码头管理有限公司'
                },
                {
                    value: '(外五)上海明东集装箱码头有限公司',
                    label: '(外五)上海明东集装箱码头有限公司'
                },
                {
                    value: '(洋三)上海冠东国际集装箱码头有限公司',
                    label: '(洋三)上海冠东国际集装箱码头有限公司'
                },
                {
                    value: '(外二)上海国际港务（集团）股份有限公司振东集装箱码头分公司',
                    label: '(外二)上海国际港务（集团）股份有限公司振东集装箱码头分公司'
                },
                {
                    value: '上海国际港务（集团）股份有限公司罗泾分公司（散货）',
                    label: '上海国际港务（集团）股份有限公司罗泾分公司（散货）'
                },
                {
                    value: '(洋四)上海国际港务（集团）股份有限公司尚东集装箱码头分公司',
                    label: '(洋四)上海国际港务（集团）股份有限公司尚东集装箱码头分公司'
                },
                { value: '非上海码头', label: '非上海码头' }
            ], //码头
            WTableOpts: {
                data: [
                    //     {
                    //   containerNo: '',//箱号
                    //   vgmWeight: '',//重量
                    //   weighingParty: '',//称重方
                    //   signature: '',//签名
                    // }
                ],
                tableAttrs: { border: false },
                tableColAttrs: [
                    // { label: '序号', type: 'index', width: '80px'},
                    { prop: 'containerNo', label: '箱号', slotName: 'containerNo' },
                    { prop: 'vgmWeight', label: 'VGM重量（KGS）', slotName: 'vgmWeight' },
                    { prop: 'weighingParty', label: '称重方', slotName: 'weighingParty' },
                    { prop: 'signature', label: '签名', slotName: 'signature' },
                    { prop: '', label: '操作', slotName: 'operation' }
                ]
            },
            formTable: {
                dataSource: [],
                tableRule: {
                    containerNo: [
                        { required: true, message: '请输入箱号', trigger: 'blur' },
                        { validator: validateXH, trigger: 'blur' }
                    ],
                    weighingParty: [
                        { required: true, message: '请输入称重方', trigger: 'blur' },
                        { validator: validCZF, trigger: 'blur' }
                    ],
                    signature: [
                        { required: true, message: '请输入签名', trigger: 'blur' },
                        { validator: validQM, trigger: 'blur' }
                    ],
                    vgmWeight: [
                        { required: true, message: '请输入VGM重量', trigger: 'blur' },
                        { validator: validZL, trigger: 'blur' }
                    ]
                }
            },
            dialogType: null, //1-退出，2-删除箱子，3-保存成功，4-数据报错
            vgmSn: '', //判断新增，编辑
            type: '',
            from: '' //草稿还是已发送
        }
    },
    computed: {
        getDialogTitle() {
            switch (this.dialogType) {
                case '1':
                    return '尚未保存数据，确认退出？'
                case '2':
                    return '箱号删除后无法恢复，确认删除？'
                case '3':
                    return '保存成功，您可以随时在草稿箱继续操作！'
                case '4':
                    return '数据不完整无法保存，请补充后重试！'
            }
            return ''
        },
        getDisabled() {
            return this.detailBack.btn == 'LOOK'
        },
        //船名，航次，码头是否显示
        showInfo() {
            return this.form.portCode == 'CNSHA' && this.carrierType == '1'
        }
    },
    watch: {
        'form.carrierCode': {
            handler(newVal, oldVal) {
                this.formCheck.soNumber = [
                    {
                        required: true,
                        message: '请输入SO号码',
                        trigger: 'blur'
                    },
                    {
                        validator: newVal == 'WHL' ? this.validWHLSO : this.validSO,
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    created() {
        // this.getPiers()
        this.vgmSn = this.$route.query.vgmId
        this.type = this.$route.query.type
        this.from = this.$route.query.from

        if (this.type == 'import') {
            const data = JSON.parse(this.$route.query.data)
            Object.keys(this.form).forEach((key) => {
                this.form[key] = data[key]
            })
            this.WTableOpts.data = data.containers
            if (data?.carrier?.easipassFlag && data.portCode == 'CNSHA') {
                this.carrierType = '1'
            }
            this.getShippingCompany()
            this.validateInfo()
        }
        //cps引流
        if (this.type == 'drainage') {
            //this.vgmDrainage()
        } else {
            //草稿箱详情
            if (this.vgmSn || this.type == 'copy') {
                this.draftBoxDetail()
            }
        }
    },
    methods: {
        carrier() {
            console.log(this.form, 365)
            return ''
        },
        //cps引流
        vgmDrainage() {
            vgmDrainage(this.vgmSn).then(async (res) => {
                Object.keys(this.form).forEach((key) => {
                    this.form[key] = res[key]
                })
                this.WTableOpts.data = res.containers
                if (res?.carrier?.easipassFlag && res.portCode == 'CNSHA') {
                    this.carrierType = '1'
                }
                this.validateInfo()
                if (this.form.portCode) {
                    const result = await getShippingCompany({
                        portCode: this.form.portCode
                    })
                    this.carriersList = result
                    const carrier = this.carriersList.find((carrier) => {
                        carrier.code == this.form.carrierCode
                    })
                    if (carrier?.easipassFlag && res.portCode == 'CNSHA') {
                        this.carrierType = '1'
                    }
                }
            })
        },
        //识别箱子的确认按钮
        submitAddContainer() {
            const obj = {
                箱号: 'containerNo',
                VGM重量: 'vgmWeight',
                称重方: 'weighingParty',
                签名: 'signature'
            }
            const pastedData = this.textarea
            const allPastedFields = pastedData.split('\n').filter((el) => el !== '')
            let header = allPastedFields[0].split('\t')
            const list = Object.keys(obj).concat(header)
            const arr = [...new Set(list)]

            if (list.length === arr.length) {
                this.$message({
                  message: '复制的箱信息不符合规范',
                  type: 'error'
                })
                return
            }
            header.forEach((v, i) => {
                for (const vKey in obj) {
                    if (v.indexOf(vKey) > -1) {
                        header[i] = obj[vKey]
                    }
                }
                // if (Object.keys(obj).includes(v)) {
                //   header[i] = obj[v]
                // }
            })
            let tableData = allPastedFields.splice(1)
            const Data = []
            tableData.forEach((el, i) => {
                let h = el.split('\t')
                console.log(h, 601)
                let element = {
                    containerNo:
                        header.indexOf('containerNo') > -1 ? h[header.indexOf('containerNo')].trim().toUpperCase() : '',
                    vgmWeight:
                        header.indexOf('vgmWeight') > -1 ? h[header.indexOf('vgmWeight')].trim().toUpperCase() : '',
                    weighingParty:
                        header.indexOf('weighingParty') > -1
                            ? h[header.indexOf('weighingParty')].trim().toUpperCase()
                            : '',
                    signature:
                        header.indexOf('signature') > -1 ? h[header.indexOf('signature')].trim().toUpperCase() : '',
                    key: Date.now()
                }

                Data.push(element)
            })
            this.WTableOpts.data = this.WTableOpts.data.concat(Data)
            this.addContainerDialogVisible = false
            this.textarea = null
        },

        //集装箱删除
        deleteData(item, index) {
            this.WTableOpts.data.splice(index, 1)
            this.$nextTick(() => {
                this.$refs.tableForm.validate((valid) => {})
            })
        },
        //确认按钮
        submit() {
            this.dialogVisible = false

            if (this.dialogType == 2 || this.dialogType == 4) {
                return
            } else {
                this.$router.go(-1)
            }
        },
        //取消按钮
        cancle() {
            this.dialogVisible = false
            if (this.dialogType == 1 || this.dialogType == 2 || this.dialogType == 4) {
                return
            } else {
                this.$router.go(-1)
            }
        },
        //详情
        draftBoxDetail() {
            draftBoxDetail({ id: this.vgmSn }).then((res) => {
                Object.keys(this.form).forEach((key) => {
                    this.form[key] = res[key]
                })
                this.WTableOpts.data = res.containers
                if (res?.carrier?.easipassFlag && res.portCode == 'CNSHA') {
                    this.carrierType = '1'
                }
                this.validateInfo()
                if (this.form.portCode) {
                    getShippingCompany({ portCode: this.form.portCode }).then((res) => {
                        this.carriersList = res
                    })
                }
            })
        },
        //保存草稿接口
        saveDraftBox() {
            const obj = {
                ...this.form,
                containers: this.WTableOpts.data
            }
            saveDraftBox(obj).then((res) => {
                this.dialogType = '3'
                //this.dialogVisible = true
                this.$message({
                  message: '保存成功，您可以随时在草稿箱继续操作！',
                  type: 'success'
                })
                this.$router.go(-1)
            })
        },
        //修改接口
        editDraftBox() {
            const obj = {
                ...this.form,
                id: this.vgmSn,
                containers: this.WTableOpts.data
            }
            editDraftBox(this.vgmSn, obj).then((res) => {
                this.dialogType = '3'
                this.$message({
                  message: '保存成功，您可以随时在草稿箱继续操作！',
                  type: 'success'
                })
                this.$router.go(-1)
                //this.dialogVisible = true
            })
        },
        //保存到草稿箱按钮
        async saveDraft() {
            console.log(this.form)
            const validForm = await new Promise((resolve) => {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                })
            })
            const validTableForm = await new Promise((resolve) => {
                this.$refs.tableForm.validate((valid) => {
                    if (valid) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                })
            })
            if (validForm && validTableForm) {
                //保存接口
                if (this.vgmSn && this.type == 'edit') {
                    this.editDraftBox()
                } else {
                    this.saveDraftBox()
                }
            } else {
                // this.dialogType = '4'
                // this.dialogVisible = true
                this.$message({
                  message: '数据不完整无法保存，请补充后重试！',
                  type: 'error'
                })
            }
        },
        //返回上一页
        toBack() {
            if (this.type == 'see') {
                this.$router.go(-1)
                return
            }
            this.dialogVisible = true
            this.dialogType = '1'
        },
        // 转大写
        toupcaseTable(val, key) {
            this.form[key] = val.toUpperCase()
        },
        //去首尾空格
        trimTexTablet(e, key) {
            this.form[key] = e.target.value.trim()
        },
        // 选择接收方后查通道
        changeCarrier() {
            const obj = this.carriersList.find((v) => {
                return v.code == this.form.carrierCode
            })
            this.carrierType = obj.easipassFlag ? '1' : ''
            // getRole({
            //   portCode: this.form.portCode,
            //   carrierCode: this.form.carrierCode
            // }).then(res => {
            //   this.carrierType = res.data
            // })
        },
        //选择港口后查询接收方
        changePort() {
            this.form.carrierCode = ''

            this.getShippingCompany()
        },
        //船司-接收方列表
        getShippingCompany() {
            getShippingCompany({ portCode: this.form.portCode }).then((res) => {
                this.carriersList = res
            })
        },
        //确认新增集装箱
        submitGoods(data) {},
        //关闭新增集装箱弹窗
        closeDialog() {},
        //校验信息
        validateInfo() {
            this.$nextTick(() => {
                this.$refs.form.validate((valid) => {})
                this.$refs.tableForm.validate((valid) => {})
            })
        },
        //新增集装箱按钮
        addGoodsDetail() {
            let index = this.WTableOpts.data.length - 1
            const firstContainer = this.WTableOpts.data[index]
            this.WTableOpts.data.push({
                containerNo: '', //箱号
                vgmWeight: '', //重量
                weighingParty: firstContainer?.weighingParty, //称重方
                signature: firstContainer?.signature //签名
            })
            this.$nextTick(() => {
                this.$refs.tableForm.validate((valid) => {})
            })
        }
    }
}
</script>

<style scoped lang="less">
.detail {
  font-size: 14px;
  background: #ffffff;
  border-radius: 4px;
  padding: 24px;
  color: #333333;

  .page-title-box {
    height: 32px;
    line-height: 32px;
    margin-bottom: 24px;
    text-align: right;

    .page-title {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      float: left;
    }
  }

  .form-part {
    height: 36px;
    background: linear-gradient(90deg, #eaf4fe 0%, rgba(198, 225, 253, 0) 100%);
    border-radius: 4px;
    line-height: 36px;
    padding-left: 24px;
    margin: 8px 0 24px 0;
  }

  .form-box {
    background: #fafafa;
    border-radius: 4px;
    padding: 24px 0;
    border-top: 2px dashed #dedede;
  }

  .el-form {
    .el-form-item {
      margin: 0 0 16px 24px;
    }

    .form-item-btn {
      width: 108px;
      margin-left: 16px;
    }

    .good-user-link {
      .iconfont {
        font-size: 12px;
        margin-right: 6px;
        margin-left: 24px;
      }
    }

    .good-user-link + .good-user-link {
      .iconfont {
        margin-left: 16px;
      }
    }

    .goods-list-title {
      min-width: 352px;
      height: 32px;
      background: linear-gradient(270deg, #ffffff 0%, #f5f9ff 100%);
      border-radius: 4px;
      line-height: 32px;
      padding-left: 16px;
      box-sizing: border-box;
      float: right;

      .goods-num {
        color: #1170eb;
        min-width: 50px;
        display: inline-block;
        text-align: center;
        padding-right: 6px;
      }
    }
  }

  .containers-list {
    ::v-deep .el-input__inner {
      //border: none;
    }

    ::v-deep .el-form .el-form-item {
      margin: 0 0 24px 0;
    }
  }

  ::v-deep .el-form .el-form-item {
    margin-bottom: 24px;
  }
  ::v-deep .el-form .el-form-item .el-form-item__label {
    line-height: 0 !important;
    height: 0;
  }
  ::v-deep .weight-party .el-input__inner {
    padding-right: 50px;
  }
}
</style>
